module.exports = __webpack_public_path__ + "img/my-cards-ico.907f3a48.svg";